import * as React from 'react';
type Props = {
  className?: string;
};
export function Lamb({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Lamb"
      className={className}
    >
      <path
        d="M27.1428 7.31483C31.6428 4.02912 37.0001 2.99995 38.4287 2.71423C39.0001 3.35709 39.4287 4.42852 39.3573 5.21423C36.7144 6.07138 33.8348 6.57137 29.4062 9.28566M4.42871 30.3571C-6.857 23.9285 9.50014 6.49995 20.8573 6.49995C21.0716 6.49995 21.2859 6.49995 21.5001 6.49995C22.2859 6.42852 23.0001 6.35709 23.7144 6.35709C26.7144 6.35709 28.2144 7.99995 30.143 10.0714C32.5001 12.5714 27.7144 15.0714 26.5716 19.7142C25.5001 23.8571 28.143 26.2857 26.5716 29.2857C22.0716 37.7142 18.7144 38.4285 14.5001 36.2142C11.5716 35.9285 8.50014 33.2142 4.42871 30.3571ZM4.42871 30.3571C12.5001 36.0714 16.5716 40.9285 23.2859 28.4285C24.8573 25.4999 22.3573 23.2142 23.3573 19.2142C24.5001 14.7142 29.0716 12.2857 26.8573 9.92852C25.0716 7.99995 23.7144 6.42852 20.7859 6.42852C9.50014 6.49995 -6.857 23.9285 4.42871 30.3571ZM30.7144 11.2142H27.5001M11.5716 21.4999C13.2144 21.4999 14.5716 22.8571 14.5716 24.4999C14.5716 26.1428 13.2144 27.4999 11.5716 27.4999C9.92871 27.4999 8.57157 26.0714 8.57157 24.4285C8.57157 22.7857 9.92871 21.4999 11.5716 21.4999Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
